import { useOrgId } from "../../../components/hooks";
import { TasksView } from "../../../components/views/TasksView";

export const ExternalTasksPage = () => {
  const orgId = useOrgId();
  return <TasksView orgId={orgId} limit={7} />;
};
